/*
 * Warenkorb: eigene Vorteilsleiste "Deine Vorteile" für Drawer und Warenkorbseite.
 *
 * Reine Theme-Anzeige für jeden Einhängepunkt [data-monk-ui] (sections/mini-cart.liquid und sections/main-cart.liquid).
 * Der Warenkorbwert kommt aus Liquid (data-cart-value in Cent, ohne _mr-Zeilen, nach Rabatten). Die Launch-Schwellen sind:
 * 60 EUR Gratis-Armband und 70 EUR Versand frei.
 *
 * Finaler Launch-Ablauf: genau ein automatisch hinzugefügtes Monk-Geschenk. Die Leiste ist reine Theme-Anzeige, liest
 * keine Monk-Elemente, ruft keine Warenkorb-Endpunkte auf und ändert den Warenkorb nicht. Ohne gültigen EUR-Wert bleibt
 * der Einhängepunkt leer.
 *
 * Der Drawer-Inhalt wird per innerHTML ersetzt (theme.js, danach cart:rerendered). Dann zeichnen wir alle Einhängepunkte
 * neu; ein bereits gezeichneter Punkt mit gleichem Wert bleibt unverändert.
 */
(function () {
  if (window.__ankerherzMonkUi) {
    return;
  }
  window.__ankerherzMonkUi = true;

  var SVG_NS = "http://www.w3.org/2000/svg";

  // Schwellen in Cent. Position = Mitte der zwei gleich breiten Spalten (25 / 75 %).
  var STEPS = [
    { cents: 6000, label: "Gratis Armband", icon: "gift", target: "zum Gratis-Armband", position: 25 },
    { cents: 7000, label: "Versand frei", icon: "shipping", target: "zum kostenlosen Versand", position: 75 },
  ];

  var ICONS = {
    gift: [
      ["rect", { x: "4", y: "11", width: "16", height: "9" }],
      ["rect", { x: "3", y: "7", width: "18", height: "4" }],
      ["path", { d: "M12 7v13" }],
      ["path", { d: "M12 7C10.5 4 7 4 7 6s3 1 5 1" }],
      ["path", { d: "M12 7c1.5-3 5-3 5-1s-3 1-5 1" }],
    ],
    shipping: [
      ["path", { d: "M2 6h11v10H2z" }],
      ["path", { d: "M13 9h4l3 3v4h-7" }],
      ["circle", { cx: "6.5", cy: "17.5", r: "1.75" }],
      ["circle", { cx: "16.5", cy: "17.5", r: "1.75" }],
    ],
  };

  var uid = 0;

  function formatMoney(cents, whole) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(amount);
    } catch (error) {
      return amount.toFixed(whole ? 0 : 2).replace(".", ",") + " €";
    }
  }

  function el(tag, className, content) {
    var node = document.createElement(tag);
    if (className) {
      node.setAttribute("class", className);
    }
    if (content !== undefined) {
      node.textContent = content;
    }
    return node;
  }

  function icon(kind) {
    var svg = document.createElementNS(SVG_NS, "svg");
    var attrs = {
      viewBox: "0 0 24 24",
      width: "18",
      height: "18",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      focusable: "false",
    };
    Object.keys(attrs).forEach(function (name) {
      svg.setAttribute(name, attrs[name]);
    });
    ICONS[kind].forEach(function (part) {
      var shape = document.createElementNS(SVG_NS, part[0]);
      Object.keys(part[1]).forEach(function (name) {
        shape.setAttribute(name, part[1][name]);
      });
      svg.appendChild(shape);
    });
    return svg;
  }

  // Füllung bis zur Mitte des erreichten Markers, dazwischen linear. Ab dem letzten Marker ist die Leiste voll.
  function fillPercent(cents) {
    var from = { cents: 0, position: 0 };
    for (var i = 0; i < STEPS.length; i++) {
      var to = STEPS[i];
      if (cents < to.cents) {
        var share = (cents - from.cents) / (to.cents - from.cents);
        return Math.round((from.position + share * (to.position - from.position)) * 100) / 100;
      }
      from = to;
    }
    return 100;
  }

  function nextStep(cents) {
    for (var i = 0; i < STEPS.length; i++) {
      if (cents < STEPS[i].cents) {
        return STEPS[i];
      }
    }
    return null;
  }

  function buildBar(cents) {
    var next = nextStep(cents);
    var titleId = "monk-ui-title-" + ++uid;
    var section = el("section", "monk-ui__benefits");
    section.setAttribute("aria-labelledby", titleId);

    var header = el("div", "monk-ui__header");
    var title = el("h3", "monk-ui__title", "Deine Vorteile");
    title.setAttribute("id", titleId);
    header.appendChild(title);
    header.appendChild(el("p", "monk-ui__next", next ? "Noch " + formatMoney(next.cents - cents) + " bis " + next.target : "Alle Vorteile freigeschaltet"));
    section.appendChild(header);

    var rail = el("div", "monk-ui__rail");
    var track = el("div", "monk-ui__track");
    track.setAttribute("aria-hidden", "true");
    var fill = el("div", "monk-ui__fill");
    fill.setAttribute("style", "--monk-ui-progress: " + fillPercent(cents) + "%");
    track.appendChild(fill);
    rail.appendChild(track);

    var list = el("ol", "monk-ui__markers");
    STEPS.forEach(function (step) {
      var reached = cents >= step.cents;
      var item = el("li", "monk-ui__marker");
      item.setAttribute("data-threshold", String(step.cents / 100));
      item.setAttribute("data-reached", reached ? "true" : "false");
      item.setAttribute("data-next", next === step ? "true" : "false");
      var symbol = el("span", "monk-ui__marker-icon");
      symbol.setAttribute("aria-hidden", "true");
      symbol.appendChild(icon(step.icon));
      item.appendChild(symbol);
      item.appendChild(el("span", "monk-ui__marker-amount", formatMoney(step.cents, true)));
      item.appendChild(el("span", "monk-ui__marker-label", step.label));
      item.appendChild(el("span", "monk-ui__marker-state visually-hidden", reached ? "erreicht" : "noch nicht erreicht"));
      list.appendChild(item);
    });
    rail.appendChild(list);
    section.appendChild(rail);
    return section;
  }

  function readCents(mount) {
    var raw = mount.getAttribute("data-cart-value");
    if (!/^\d+$/.test(raw || "") || mount.getAttribute("data-cart-currency") !== "EUR") {
      return null;
    }
    return parseInt(raw, 10);
  }

  function render(mount) {
    var cents = readCents(mount);
    if (cents === null) {
      if (mount.childNodes.length > 0) {
        mount.textContent = "";
      }
      mount.removeAttribute("data-monk-ui-state");
      mount.removeAttribute("data-monk-ui-value");
      return;
    }
    if (mount.getAttribute("data-monk-ui-state") === "ready" && mount.getAttribute("data-monk-ui-value") === String(cents) && mount.childElementCount > 0) {
      return;
    }
    mount.textContent = "";
    mount.appendChild(buildBar(cents));
    mount.setAttribute("data-monk-ui-value", String(cents));
    mount.setAttribute("data-monk-ui-state", "ready");
  }

  function renderAll() {
    var mounts = document.querySelectorAll("[data-monk-ui]");
    for (var i = 0; i < mounts.length; i++) {
      render(mounts[i]);
    }
  }

  document.addEventListener("cart:rerendered", renderAll);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderAll);
  } else {
    renderAll();
  }
})();
